"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MobilePopover_1 = require("../wizards/components/MobilePopover");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const renderSelectorButton = () => (React.createElement("svg", { width: "8px", height: "4px", viewBox: "0 0 8 4" },
    React.createElement("g", { id: "Report-/-Scheduled", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "Chart", transform: "translate(-152.000000, -10.000000)", fill: "#FFFFFF" },
            React.createElement("g", { id: "Chart-Selector" },
                React.createElement("polygon", { id: "Triangle", transform: "translate(156.000000, 12.000000) scale(1, -1) translate(-156.000000, -12.000000) ", points: "156 10 160 14 152 14" }))))));
const GraphSelector = ({ activePopover, closePopoverModalForm, device, isPopoverModalFormOpen, reportGraphType, updateActivePopover, updateReportGraphType, }) => {
    const selectorStyle = {
        display: 'flex',
        alignItems: 'center',
        height: device === 'Mobile' ? 72 : 56,
        justifyContent: 'space-between',
        width: device === 'Mobile' ? 'auto' : 320,
    };
    const selectReportType = (reportType) => {
        updateReportGraphType(reportType);
        closePopoverModalForm();
        setTimeout(() => updateActivePopover(''), 500);
    };
    const renderSelectors = () => (React.createElement(src_1.SelectableList, { device: device },
        React.createElement("div", { onClick: () => selectReportType('opened'), style: selectorStyle, key: "select-opened-notification-graph" },
            React.createElement(src_1.Text, { text: "Notification Opened", size: "medium" }),
            React.createElement(src_1.RadioButton, { selected: reportGraphType === 'opened', style: { outerStyle: { height: 18, width: 18 } } })),
        React.createElement("div", { onClick: () => selectReportType('delivered'), style: selectorStyle, key: "select-delivered-notification-graph" },
            React.createElement(src_1.Text, { text: "Notification Delivered", size: "medium" }),
            React.createElement(src_1.RadioButton, { selected: reportGraphType === 'delivered', style: { outerStyle: { height: 18, width: 18 } } }))));
    return device === 'Mobile' ? (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: () => updateActivePopover('graph-selector'), style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
            } },
            React.createElement(src_1.Text, { size: "medium", textStyle: Object.assign(Object.assign({}, src_1.light), { color: src_1.white, marginRight: 8 }), text: reportGraphType === 'opened' ? 'Notifications Opened' : 'Notifications Delivered' }),
            renderSelectorButton()),
        activePopover === 'graph-selector' &&
            ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { animation: isPopoverModalFormOpen, navbarProps: {
                    buttonLeftCallback: () => {
                        closePopoverModalForm();
                        setTimeout(() => updateActivePopover(''), 500);
                    },
                } }, renderSelectors()), document.getElementById('mainModalLeft')))) : (React.createElement(src_1.PopoverContainer, { id: "graph-selector", onClick: () => {
            activePopover === 'graph-selector' ? updateActivePopover('') : updateActivePopover('graph-selector');
        }, popoverProps: {
            placement: 'right',
            device: device,
        }, showPopover: activePopover === 'graph-selector', targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft' },
        React.createElement("div", { style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
            } },
            React.createElement(src_1.Text, { size: "medium", textStyle: Object.assign(Object.assign({}, src_1.light), { color: src_1.white, marginRight: 8 }), text: reportGraphType === 'opened' ? 'Notifications Opened' : 'Notifications Delivered' }),
            renderSelectorButton()),
        renderSelectors()));
};
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    isPopoverModalFormOpen: reducers_1.getIsPopoverModalFormOpen(state),
    reportGraphType: reducers_1.getReportGraphType(state),
});
const mapDispatchToProps = (dispatch) => ({
    closePopoverModalForm: () => dispatch(actions_1.closePopoverModalForm()),
    updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
    updateReportGraphType: (type) => dispatch(actions_1.updateReportGraphType(type)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GraphSelector);
